import {FormArray, FormBuilder, FormControl, Validators} from '@angular/forms';
import {GenericObjectTypeInfo} from '@catcore/types/base';
import {Resource} from '@catfeatures/types';
import {isNullOrUndefined} from 'util';

const extractValueForPropertyName = (propertyName: string, propertyType: string, resource: Resource): any => {
  let propertyValue = null;

  const resourcePropertyKeys = Object.keys(resource);
  const linkedResources = resource._links ? resource._links : {};
  const linkedResourcesKeys = Object.keys(linkedResources);
  const isLinkedObject = linkedResourcesKeys.includes(propertyName) && propertyType === GenericObjectTypeInfo.Object;
  const isLinkedList = linkedResourcesKeys.includes(propertyName) && propertyType === GenericObjectTypeInfo.Array;

  if (resourcePropertyKeys.includes(propertyName)) {
    propertyValue = resource[propertyName];
  }

  if (isLinkedObject) {
    propertyValue = linkedResources[propertyName].href;
  }

  if (isLinkedList) {
    propertyValue = [];
    linkedResources[propertyName].forEach((listItem) => {
      propertyValue.push(listItem.href);
    });
  }

  return propertyValue;
};

export const extractDefaultValue = (propertyName: string, schema: any): any => {
  let propertyValue = null;
  const availablePropertyNames = Object.keys(schema.properties);

  if (availablePropertyNames.includes(propertyName)) {
    switch (schema.properties[propertyName].type) {
      case GenericObjectTypeInfo.Array:
        propertyValue = [];
        break;
    }
  }
  return propertyValue;
};

export const buildFormControlsFromSchema = (formBuilder: FormBuilder, schema: any, formData: any = {}) => {

  const schemaPropertyKeys = Object.keys(schema.properties);
  const formControls = {};
  const excludeProperties: string[] = [];

  schemaPropertyKeys.forEach((propertyName) => {
    const typeDef = schema.properties[propertyName];

    const validationsForEntity = buildValidationRules(propertyName, schema);
    const doApplyAsControl = !excludeProperties.includes(propertyName);
    let propertyValue = extractValueForPropertyName(propertyName, typeDef.type, formData);

    if (isNullOrUndefined(propertyValue)) {
      propertyValue = extractDefaultValue(propertyName, schema);
    }

    if (doApplyAsControl) {
      if (typeDef.type === 'array') {
        formControls[propertyName] = new FormArray([]);
        propertyValue.forEach((val) => {
          formControls[propertyName].push(new FormControl(val, validationsForEntity));
        });
      } else {
        formControls[propertyName] = new FormControl(propertyValue, validationsForEntity);
      }
    }
  });

  return formControls;
};

export const buildFormControlsFromSchemaForCreate = (formBuilder: FormBuilder, schema: any, excludeProperties = []) => {
  const schemaPropertyKeys = Object.keys(schema.properties);
  const formControls = {};

  schemaPropertyKeys.forEach((propertyName) => {
    const typeDef = schema.properties[propertyName];
    const validationsForEntity = buildValidationRules(propertyName, schema);

    if (!typeDef) {
      return;
    }

    if (typeDef.type !== 'array' && !excludeProperties.includes(propertyName)) {
      formControls[propertyName] = new FormControl('', validationsForEntity);
    }
  });
  return formControls;
};

const buildValidationRules = (propertyName: string, schema: any): any[] => {
  const rules = [];

  if (schema.required.includes(propertyName)) {
    rules.push(Validators.required);
  }

  return rules;
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/shared/form-builder.ts